export function createRoutes() {
  return [
    {
      path: 'galleries',
      component: () => import(/* webpackChunkName: "GalleryChrome" */ './GalleryChrome.vue'),
      children: [
        {
          path: '/',
          name: 'galleriesList',
          component: () => import(/* webpackChunkName: "GalleriesList" */ './GalleriesList.vue'),
        },
        {
          path: ':galleryKey',
          name: 'galleryEdit',
          component: () => import(/* webpackChunkName: "GalleryEdit" */ './GalleryEdit.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
